import React from 'react';

import { observer } from 'mobx-react';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { ChatConversationType } from '@bringg/types';

import { Avatar, Link } from '../../../components';
import { useChatStore } from '../stores/use-chat-store';

const ChatWindowHeader = observer(() => {
	const { chatStore } = useChatStore();
	const chat = chatStore.getCurrentChat;
	const isChatTypeTask = chat.conversation_type === ChatConversationType.task || chat.conversation_type === 'task';

	return chat ? (
		<div className="chat-window-header">
			<span className="chat-window-header-image">
				{isChatTypeTask ? (
					<div className="task-icon">
						<BringgIcon iconName={BringgFontIcons.Location} />
					</div>
				) : (
					<Avatar key={chat.id} className="chat-item-image" src={chat.getImageUrl} />
				)}
			</span>
			<span className="chat-window-header-title">
				<Link to={isChatTypeTask ? `/history/${chat.task_id}` : `/drivers/${chat.driver_id}`}>
					{chat.getTitle}
				</Link>
			</span>
		</div>
	) : null;
});

export default ChatWindowHeader;
